import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import InputPage from "./pages/input";
import Statistics from "./pages/statistics";
import HistoryPage from "./pages/history";
import LandingPage from "./pages/home";
import SelectionPage from "./pages/selection";
import TrainingPage from "./pages/training";

import Login from "./components/login";
import store from "./store";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import ProtectedRoute from "./components/ProtectedRoute";
import SettingsPage from "./pages/settings";
import Impressum from "./pages/imprint";
import PrivacyPolicy from "./pages/privacy";

import "./styles/App.css";
import "./index.css";
import "./i18n";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <Router>
          <div className="min-h-screen flex flex-col min-w-[290px]">
            <Navbar />
            <main className="flex-grow flex flex-col pt-16 pb-16">
              <div className="flex-grow flex flex-col">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/selection" element={<SelectionPage />} />
                  <Route path="/tracking" element={<InputPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/legal-notice" element={<Impressum />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                  <Route
                    path="/training"
                    element={<ProtectedRoute element={<TrainingPage />} />}
                  />
                  <Route
                    path="/settings"
                    element={<ProtectedRoute element={<SettingsPage />} />}
                  />
                  <Route
                    path="/statistics"
                    element={<ProtectedRoute element={<Statistics />} />}
                  />
                  <Route
                    path="/history"
                    element={<ProtectedRoute element={<HistoryPage />} />}
                  />

                  {/* Fallback to landing page */}
                  <Route path="*" element={<LandingPage />} />
                </Routes>
              </div>
            </main>
            <Footer />
          </div>
        </Router>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// Register the service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
  onSuccess: (registration) => {
    console.log("Service worker registration successful");
  },
  onError: (error) => {
    console.error("Service worker registration failed:", error);
  },
});
